const hero = document.querySelector('.hero');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
const layers = [...document.querySelectorAll('.hero-image')].map(element => ({
  element,
  depth: Number(element.dataset.depth),
  scrollDepth: Number(element.dataset.scrollDepth),
  x: 0, y: 0, targetX: 0, targetY: 0,
}));
let pointerX = 0;
let pointerY = 0;
let frame = 0;

function animate() {
  frame = 0;
  let moving = false;
  for (const layer of layers) {
    layer.x += (layer.targetX - layer.x) * 0.085;
    layer.y += (layer.targetY - layer.y) * 0.085;
    if (Math.abs(layer.targetX - layer.x) > 0.03 || Math.abs(layer.targetY - layer.y) > 0.03) moving = true;
    layer.element.style.setProperty('--parallax-x', `${layer.x.toFixed(2)}px`);
    layer.element.style.setProperty('--parallax-y', `${layer.y.toFixed(2)}px`);
  }
  if (moving) frame = requestAnimationFrame(animate);
}

function updateTargets() {
  if (reducedMotion.matches) {
    cancelAnimationFrame(frame);
    frame = 0;
    for (const layer of layers) {
      layer.x = layer.y = layer.targetX = layer.targetY = 0;
      layer.element.style.setProperty('--parallax-x', '0px');
      layer.element.style.setProperty('--parallax-y', '0px');
    }
    return;
  }
  const rect = hero.getBoundingClientRect();
  const scrollOffset = Math.max(0, Math.min(-rect.top, rect.height));
  const scale = finePointer.matches && rect.width > 600 ? 1 : 0.55;
  for (const layer of layers) {
    layer.targetX = pointerX * layer.depth * scale;
    layer.targetY = (pointerY * layer.depth - Math.min(scrollOffset * layer.scrollDepth, 24)) * scale;
  }
  if (!frame) frame = requestAnimationFrame(animate);
}

hero.addEventListener('pointermove', event => {
  if (event.pointerType !== 'mouse' || !finePointer.matches || reducedMotion.matches) return;
  const rect = hero.getBoundingClientRect();
  pointerX = Math.max(-1, Math.min(1, (event.clientX - rect.left) / rect.width * 2 - 1));
  pointerY = Math.max(-1, Math.min(1, (event.clientY - rect.top) / rect.height * 2 - 1));
  updateTargets();
}, { passive: true });
hero.addEventListener('pointerleave', () => { pointerX = pointerY = 0; updateTargets(); });
window.addEventListener('scroll', updateTargets, { passive: true });
window.addEventListener('resize', updateTargets, { passive: true });
reducedMotion.addEventListener('change', updateTargets);
finePointer.addEventListener('change', () => { pointerX = pointerY = 0; updateTargets(); });
updateTargets();

// Open service details before the browser follows the circle's anchor.
document.querySelectorAll('.service-circle').forEach(link => {
  link.addEventListener('click', event => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const detail = document.getElementById(link.hash.slice(1));
    if (!detail || detail.tagName !== 'DETAILS') return;
    detail.open = true;
    detail.querySelector('summary').focus({ preventScroll: true });
  });
});

function revealLinkedService() {
  const detail = document.getElementById(window.location.hash.slice(1));
  if (detail && detail.matches('.service-list details')) detail.open = true;
}
window.addEventListener('hashchange', revealLinkedService);
revealLinkedService();

// A dense gallery with a focused view that rearranges the remaining photographs.
// Each category carries its own number of photographs, so the tiles themselves are
// built and retired as the category changes.
const portfolioData = JSON.parse(document.getElementById('portfolio-data').textContent);
const portfolioStage = document.querySelector('.portfolio-stage');
const portfolioPanel = document.querySelector('.portfolio-panel');
const portfolioTabs = [...document.querySelectorAll('.portfolio-tabs [role="tab"]')];
const portfolioStatus = document.getElementById('portfolio-status');
const portfolioMobile = window.matchMedia('(max-width: 700px)');
const portfolioCache = new Map();
const portfolioAnimations = new Set();
let portfolioTiles = [...portfolioStage.querySelectorAll('.portfolio-tile')];
let portfolioCategory = portfolioStage.dataset.category || 'plants';
let portfolioRequested = portfolioCategory;
let portfolioSelected = -1;
let portfolioRequest = 0;
let portfolioRender = 0;

function loadPortfolio(category) {
  if (!portfolioCache.has(category)) {
    const loading = Promise.all(portfolioData[category].map(photo => new Promise((resolve, reject) => {
      const image = new Image(photo.width, photo.height);
      image.alt = photo.alt;
      image.decoding = 'async';
      if (photo.fit) image.dataset.fit = photo.fit;
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error(`Unable to load ${photo.src}`));
      image.src = photo.src;
      if (image.complete && image.naturalWidth > 0) resolve(image);
    })));
    portfolioCache.set(category, loading);
    loading.catch(() => portfolioCache.delete(category));
  }
  return portfolioCache.get(category);
}

function portfolioAnimate(element, frames, options) {
  const animation = element.animate(frames, {fill: 'both', ...options});
  portfolioAnimations.add(animation);
  animation.finished.catch(() => {}).finally(() => portfolioAnimations.delete(animation));
  return animation;
}

function buildPortfolioTile() {
  const tile = document.createElement('figure');
  tile.className = 'portfolio-tile';
  const caption = document.createElement('figcaption');
  caption.className = 'portfolio-index';
  caption.setAttribute('aria-hidden', 'true');
  const button = document.createElement('button');
  button.className = 'portfolio-photo-frame';
  button.type = 'button';
  button.setAttribute('aria-pressed', 'false');
  button.append(document.createElement('img'));
  button.addEventListener('click', () => {
    const index = portfolioTiles.indexOf(tile);
    if (index >= 0) togglePortfolioPhoto(index);
  });
  tile.append(caption, button);
  return tile;
}

// Grow or retire tiles so the stage matches the category, returning the retired ones
// so they can be faded out rather than vanishing mid-animation.
function syncPortfolioTiles(count) {
  const added = [];
  const removed = portfolioTiles.slice(count);
  while (portfolioTiles.length < count) {
    const tile = buildPortfolioTile();
    portfolioStage.append(tile);
    portfolioTiles.push(tile);
    added.push(tile);
  }
  portfolioTiles = portfolioTiles.slice(0, count);
  portfolioTiles.forEach((tile, index) => {
    tile.dataset.slot = String(index + 1);
    tile.querySelector('.portfolio-index').textContent = `(${String(index + 1).padStart(2, '0')})`;
  });
  return {added, removed};
}

function cleanPortfolioPhotos() {
  portfolioTiles.forEach(tile => {
    const frame = tile.querySelector('.portfolio-photo-frame');
    const latest = frame.lastElementChild;
    if (!latest) return;
    [...frame.children].forEach(image => { if (image !== latest) image.remove(); });
    latest.style.opacity = '1';
    latest.style.transform = 'none';
    latest.removeAttribute('aria-hidden');
  });
}

function applyPortfolioLayout() {
  const photos = portfolioData[portfolioCategory];
  const layout = computePortfolioLayout(portfolioStage.clientWidth, portfolioCategory, portfolioSelected,
    photos.map(photo => photo.width / photo.height), portfolioMobile.matches);
  portfolioStage.classList.add('is-arranged');
  portfolioStage.dataset.category = portfolioCategory;
  portfolioStage.dataset.expanded = portfolioSelected < 0 ? 'none' : String(portfolioSelected + 1);
  portfolioStage.style.height = `${layout.height}px`;
  portfolioTiles.forEach((tile, index) => {
    const bounds = layout.rects[index];
    if (!bounds) return;
    const expanded = index === portfolioSelected;
    tile.style.setProperty('--x', `${bounds.x}px`);
    tile.style.setProperty('--y', `${bounds.y}px`);
    tile.style.setProperty('--w', `${bounds.width}px`);
    tile.style.setProperty('--h', `${bounds.height}px`);
    tile.classList.toggle('is-expanded', expanded);
    const button = tile.querySelector('button');
    button.setAttribute('aria-pressed', String(expanded));
    button.setAttribute('aria-label', `${expanded ? 'Reduce' : 'Enlarge'} photograph ${index + 1}: ${photos[index].alt}`);
  });
  return layout;
}

async function transitionPortfolio(incoming = null, focusSelected = false) {
  const render = ++portfolioRender;
  const previous = new Map(portfolioTiles.map(tile => [tile, tile.getBoundingClientRect()]));
  const oldHeight = portfolioStage.getBoundingClientRect().height;
  portfolioAnimations.forEach(animation => animation.cancel());
  portfolioAnimations.clear();
  cleanPortfolioPhotos();

  const count = portfolioData[portfolioCategory].length;
  const {added, removed} = syncPortfolioTiles(count);
  const layout = applyPortfolioLayout();
  const animations = [];
  const duration = portfolioMobile.matches ? 320 : 620;
  const easing = 'cubic-bezier(.22,1,.36,1)';

  removed.forEach(tile => {
    if (reducedMotion.matches) { tile.remove(); return; }
    const fade = portfolioAnimate(tile, [{opacity: 1}, {opacity: 0}], {duration: 180, easing: 'ease-out'});
    fade.finished.catch(() => {}).finally(() => tile.remove());
    animations.push(fade);
  });

  if (!reducedMotion.matches && Math.abs(oldHeight - layout.height) > 1) {
    animations.push(portfolioAnimate(portfolioStage, [
      {height: `${oldHeight}px`}, {height: `${layout.height}px`},
    ], {duration, easing}));
  }

  portfolioTiles.forEach((tile, index) => {
    const first = previous.get(tile);
    const last = tile.getBoundingClientRect();
    if (!reducedMotion.matches) {
      if (first && first.width > 0 && last.width > 0) {
        animations.push(portfolioAnimate(tile, [
          {transform: `translate(${first.left - last.left}px, ${first.top - last.top}px) scale(${first.width / last.width}, ${first.height / last.height})`},
          {transform: 'none'},
        ], {duration, delay: portfolioMobile.matches ? 0 : Math.min(index, 8) * 18, easing}));
      } else {
        // A tile that did not exist a moment ago simply arrives.
        animations.push(portfolioAnimate(tile, [{opacity: 0}, {opacity: 1}],
          {duration: 260, delay: 60 + Math.min(index, 8) * 24, easing}));
      }
    }
    if (!incoming) return;
    const frame = tile.querySelector('.portfolio-photo-frame');
    const oldImage = frame.lastElementChild;
    const newImage = incoming[index].cloneNode();
    if (!added.includes(tile) && oldImage && !reducedMotion.matches) {
      oldImage.setAttribute('aria-hidden', 'true');
      newImage.style.opacity = '0';
      frame.append(newImage);
      animations.push(portfolioAnimate(oldImage, [{opacity: 1}, {opacity: 0}], {
        duration: 200, delay: Math.min(index, 8) * 20, easing: 'ease-out',
      }));
      animations.push(portfolioAnimate(newImage, [
        {opacity: 0, transform: `translateY(${portfolioMobile.matches ? 0 : 8}px)`},
        {opacity: 1, transform: 'translateY(0)'},
      ], {duration: portfolioMobile.matches ? 220 : 360, delay: 50 + Math.min(index, 8) * 30, easing}));
    } else {
      if (oldImage) oldImage.remove();
      frame.append(newImage);
    }
  });

  await Promise.allSettled(animations.map(animation => animation.finished));
  if (render !== portfolioRender) return;
  cleanPortfolioPhotos();
  animations.forEach(animation => animation.cancel());
  const label = portfolioTabs.find(tab => tab.dataset.category === portfolioCategory).textContent;
  portfolioStatus.textContent = portfolioSelected < 0
    ? `Showing ${count} ${label} photographs.`
    : `Photograph ${portfolioSelected + 1} enlarged. Select it again or press Escape to restore the gallery.`;
  if (focusSelected && portfolioSelected >= 0) {
    const selectedTile = portfolioTiles[portfolioSelected];
    const bounds = selectedTile.getBoundingClientRect();
    if (bounds.top < 20 || bounds.bottom > window.innerHeight - 20) {
      selectedTile.scrollIntoView({block: 'nearest', behavior: reducedMotion.matches ? 'auto' : 'smooth'});
    }
  }
}

async function selectPortfolio(category) {
  if (category === portfolioRequested) return;
  portfolioRequested = category;
  const request = ++portfolioRequest;
  portfolioPanel.setAttribute('aria-busy', 'true');
  let incoming;
  try {
    incoming = await loadPortfolio(category);
  } catch {
    if (request !== portfolioRequest) return;
    portfolioRequested = portfolioCategory;
    portfolioPanel.removeAttribute('aria-busy');
    portfolioStatus.textContent = 'These photographs could not load. Please try the category again.';
    return;
  }
  if (request !== portfolioRequest) return;
  portfolioCategory = category;
  portfolioSelected = -1;
  portfolioTabs.forEach(tab => {
    const selected = tab.dataset.category === category;
    tab.setAttribute('aria-selected', String(selected));
    tab.tabIndex = selected ? 0 : -1;
  });
  portfolioPanel.setAttribute('aria-labelledby', `portfolio-tab-${category}`);
  portfolioPanel.removeAttribute('aria-busy');
  transitionPortfolio(incoming);
  renderMobilePortfolio();
}

function togglePortfolioPhoto(index) {
  // A more recent photo click supersedes any category still loading.
  portfolioRequest++;
  portfolioRequested = portfolioCategory;
  portfolioPanel.removeAttribute('aria-busy');
  portfolioSelected = portfolioSelected === index ? -1 : index;
  transitionPortfolio(null, portfolioSelected >= 0);
}

portfolioPanel.addEventListener('keydown', event => {
  if (event.key !== 'Escape' || portfolioSelected < 0) return;
  event.preventDefault();
  const index = portfolioSelected;
  togglePortfolioPhoto(index);
  portfolioTiles[index].querySelector('button').focus({preventScroll: true});
});
portfolioTabs.forEach((tab, index) => {
  tab.addEventListener('click', () => selectPortfolio(tab.dataset.category));
  tab.addEventListener('pointerenter', () => loadPortfolio(tab.dataset.category).catch(() => {}));
  tab.addEventListener('focus', () => loadPortfolio(tab.dataset.category).catch(() => {}));
  tab.addEventListener('keydown', event => {
    let next;
    if (event.key === 'ArrowRight') next = (index + 1) % portfolioTabs.length;
    if (event.key === 'ArrowLeft') next = (index + portfolioTabs.length - 1) % portfolioTabs.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = portfolioTabs.length - 1;
    if (next === undefined) return;
    event.preventDefault();
    portfolioTabs[next].focus({preventScroll: true});
    selectPortfolio(portfolioTabs[next].dataset.category);
  });
});

// Tiles present in the markup already carry their click handler through delegation below.
portfolioTiles.forEach(tile => {
  tile.querySelector('button').addEventListener('click', () => {
    const index = portfolioTiles.indexOf(tile);
    if (index >= 0) togglePortfolioPhoto(index);
  });
});

function settlePortfolioMotion() {
  portfolioAnimations.forEach(animation => { if (animation.playState !== 'idle') animation.finish(); });
}
reducedMotion.addEventListener('change', settlePortfolioMotion);
window.addEventListener('resize', () => {
  settlePortfolioMotion();
  applyPortfolioLayout();
}, {passive: true});
applyPortfolioLayout();
// Only the visible category is fetched up front; the others prefetch on tab hover or focus.
const portfolioObserver = new IntersectionObserver(entries => {
  if (!entries.some(entry => entry.isIntersecting)) return;
  loadPortfolio(portfolioCategory).catch(() => {});
  portfolioObserver.disconnect();
}, {rootMargin: '400px'});
portfolioObserver.observe(portfolioStage);

// Three process chapters share one composition. Without JS, all copy stays readable.
const processStory = document.querySelector('.process-story');
if (processStory) {
  const tabs = [...processStory.querySelectorAll('[role="tab"]')];
  const panels = [...processStory.querySelectorAll('.process-panel')];
  const scenes = [...processStory.querySelectorAll('.process-scene')];
  let selected = 0;

  function showProcessChapter(index, animate = true) {
    selected = index;
    tabs.forEach((tab, i) => {
      const active = i === index;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      panels[i].hidden = !active;
      panels[i].inert = !active;
      panels[i].classList.toggle('is-current', active);
      panels[i].classList.remove('is-entering');
      if (active && animate && !reducedMotion.matches) panels[i].classList.add('is-entering');
      scenes[i].classList.toggle('is-current', active);
      scenes[i].setAttribute('aria-hidden', String(!active));
    });
  }

  panels.forEach((panel, index) => {
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('aria-labelledby', tabs[index].id);
    panel.tabIndex = 0;
  });
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      if (selected !== index) showProcessChapter(index);
    });
    tab.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else return;
      event.preventDefault();
      tabs[next].focus({preventScroll: true});
      if (selected !== next) showProcessChapter(next);
    });
  });
  processStory.classList.add('is-enhanced');
  processStory.querySelector('.process-tabs').hidden = false;
  showProcessChapter(0, false);
}

// Service rows carry the most detail on the page, so they open with motion rather
// than snapping: the panel grows, then its blocks arrive in sequence. Reduced motion
// and no-JS both fall back to the native details behaviour.
const serviceRows = [...document.querySelectorAll('.service-list details')];
const serviceEasing = 'cubic-bezier(.22,1,.36,1)';

function revealServiceContent(content) {
  if (reducedMotion.matches) return;
  // Stagger the panel's own blocks, then the tier or option cards inside them.
  const blocks = [...content.children];
  const cards = [...content.querySelectorAll('.service-options > *, .floral-prices > *')];
  blocks.forEach((element, index) => {
    element.animate([
      {opacity: 0, transform: 'translateY(14px)'},
      {opacity: 1, transform: 'none'},
    ], {duration: 520, delay: 90 + index * 90, easing: serviceEasing, fill: 'backwards'});
  });
  cards.forEach((element, index) => {
    element.animate([
      {opacity: 0, transform: 'translateY(18px)'},
      {opacity: 1, transform: 'none'},
    ], {duration: 560, delay: 220 + index * 80, easing: serviceEasing, fill: 'backwards'});
  });
}

serviceRows.forEach(detail => {
  const summary = detail.querySelector('summary');
  const content = detail.querySelector('.service-content');
  if (!summary || !content) return;
  let motion = null;

  summary.addEventListener('click', event => {
    if (reducedMotion.matches) return;           // let the browser do it
    event.preventDefault();
    if (motion) motion.cancel();
    content.classList.add('is-animating');
    const opening = !detail.open;

    if (opening) {
      detail.open = true;
      const height = content.scrollHeight;
      motion = content.animate([
        {height: '0px', opacity: 0}, {height: `${height}px`, opacity: 1},
      ], {duration: 460, easing: serviceEasing});
      revealServiceContent(content);
    } else {
      motion = content.animate([
        {height: `${content.scrollHeight}px`, opacity: 1}, {height: '0px', opacity: 0},
      ], {duration: 320, easing: serviceEasing});
      motion.finished.then(() => { detail.open = false; }).catch(() => {});
    }
    motion.finished.catch(() => {}).finally(() => {
      content.classList.remove('is-animating');
      motion = null;
    });
  });
});

// Mobile navigation keeps the same links and typeface as the desktop header.
const menuToggle = document.querySelector('.menu-toggle');
const mainNavigation = document.querySelector('#main-navigation');
function closeMenu() {
  menuToggle.setAttribute('aria-expanded', 'false');
  menuToggle.setAttribute('aria-label', 'Open menu');
}
menuToggle.addEventListener('click', () => {
  const open = menuToggle.getAttribute('aria-expanded') !== 'true';
  menuToggle.setAttribute('aria-expanded', String(open));
  menuToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
});
mainNavigation.addEventListener('click', event => { if (event.target.closest('a')) closeMenu(); });
document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && menuToggle.getAttribute('aria-expanded') === 'true') {
    closeMenu(); menuToggle.focus();
  }
});
document.addEventListener('click', event => { if (!event.target.closest('.masthead')) closeMenu(); });

// Native scroll snapping provides touch swiping without intercepting page scrolling.
const mobileGallery = document.createElement('div');
mobileGallery.className = 'mobile-gallery';
portfolioPanel.append(mobileGallery);
function renderMobilePortfolio() {
  const photos = portfolioData[portfolioCategory];
  mobileGallery.replaceChildren();
  const track = document.createElement('div');
  track.className = 'mobile-gallery-track';
  track.tabIndex = 0;
  track.setAttribute('aria-label', 'Portfolio photographs, swipe or use arrow keys');
  const thumbs = document.createElement('div');
  thumbs.className = 'mobile-gallery-thumbs';
  thumbs.setAttribute('aria-label', 'Choose a photograph');
  const counter = document.createElement('p');
  counter.className = 'mobile-gallery-counter';
  counter.setAttribute('aria-live', 'polite');
  let active = 0;
  const buttons = [];
  function select(index, scroll = true) {
    active = Math.max(0, Math.min(photos.length - 1, index));
    buttons.forEach((button, i) => button.setAttribute('aria-current', String(i === active)));
    counter.textContent = `${active + 1} / ${photos.length}`;
    if (scroll) track.scrollTo({left: active * track.clientWidth, behavior: reducedMotion.matches ? 'auto' : 'smooth'});
    const button = buttons[active];
    if (button.offsetLeft < thumbs.scrollLeft || button.offsetLeft + button.offsetWidth > thumbs.scrollLeft + thumbs.clientWidth) {
      thumbs.scrollTo({left: button.offsetLeft - (thumbs.clientWidth - button.offsetWidth) / 2, behavior: 'smooth'});
    }
  }
  photos.forEach((photo, index) => {
    const slide = document.createElement('div');
    slide.className = 'mobile-gallery-slide';
    const img = document.createElement('img');
    img.src = photo.src; img.alt = photo.alt; img.loading = index ? 'lazy' : 'eager';
    slide.append(img); track.append(slide);
    const button = document.createElement('button');
    button.type = 'button'; button.setAttribute('aria-label', `View photograph ${index + 1}`);
    const thumbnail = document.createElement('img');
    thumbnail.src = photo.src; thumbnail.alt = ''; thumbnail.loading = 'lazy';
    button.append(thumbnail); button.addEventListener('click', () => select(index));
    buttons.push(button); thumbs.append(button);
  });
  track.addEventListener('scroll', () => {
    const index = Math.round(track.scrollLeft / track.clientWidth);
    if (Number.isFinite(index) && index !== active) select(index, false);
  }, {passive: true});
  track.addEventListener('keydown', event => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault(); select(active + (event.key === 'ArrowRight' ? 1 : -1));
  });
  mobileGallery.append(track, thumbs, counter);
  select(0, false);
}
renderMobilePortfolio();

// Three mobile merchandise slides share native touch scrolling and dot navigation.
const merchTrack = document.querySelector('.merch-grid');
const merchCards = [...merchTrack.querySelectorAll('.merch-card')];
const merchDots = document.createElement('div');
merchDots.className = 'merch-dots';
merchDots.setAttribute('role', 'group');
merchDots.setAttribute('aria-label', 'Choose merchandise item');
merchTrack.id = 'merch-products';
const merchButtons = merchCards.map((card, index) => {
  const button = document.createElement('button');
  button.type = 'button';
  button.setAttribute('aria-label', `Show ${card.querySelector('h3').textContent}, item ${index + 1} of 3`);
  button.setAttribute('aria-controls', 'merch-products');
  button.setAttribute('aria-current', String(index === 0));
  button.addEventListener('click', () => {
    const left = card.getBoundingClientRect().left - merchTrack.getBoundingClientRect().left + merchTrack.scrollLeft;
    merchTrack.scrollTo({left, behavior: reducedMotion.matches ? 'auto' : 'smooth'});
  });
  merchDots.append(button);
  return button;
});
merchTrack.after(merchDots);
function updateMerchDots() {
  const left = merchTrack.getBoundingClientRect().left;
  let active = 0;
  merchCards.forEach((card, index) => {
    if (Math.abs(card.getBoundingClientRect().left - left) < Math.abs(merchCards[active].getBoundingClientRect().left - left)) active = index;
  });
  merchButtons.forEach((button, index) => button.setAttribute('aria-current', String(index === active)));
}
merchTrack.addEventListener('scroll', updateMerchDots, {passive: true});
window.addEventListener('resize', updateMerchDots, {passive: true});
